import React from 'react';
import { Spinner } from 'reactstrap';

import styles from './style.module.scss';

interface Props {
  status: boolean;
  fromFilter?:boolean
}

interface State {
}

export default class PageLoader extends React.Component<Props, State> {
  constructor(props) {
    super(props);
  }

  render(): React.ReactNode {
    if (!this.props.status) {
      return null;
    }

    return (
      <div className={styles['loading-container']} style={{ background: this.props.fromFilter ? 'none': ''}}>
        <Spinner className={styles['loading-icon']}>Loading...</Spinner>
      </div>
    );
  }
}
